/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateQuickReplyRequest
 */
export interface CreateQuickReplyRequest {
    /**
     * Short machine-readable name used to trigger the quick reply (no spaces)
     * @type {string}
     * @memberof CreateQuickReplyRequest
     */
    shortName: string;
    /**
     * Human-readable description of what this quick reply is for
     * @type {string}
     * @memberof CreateQuickReplyRequest
     */
    description: string;
    /**
     * The message text that will be sent when this quick reply is used
     * @type {string}
     * @memberof CreateQuickReplyRequest
     */
    message: string;
}

/**
 * Check if a given object implements the CreateQuickReplyRequest interface.
 */
export function instanceOfCreateQuickReplyRequest(value: object): value is CreateQuickReplyRequest {
    if (!('shortName' in value) || value['shortName'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function CreateQuickReplyRequestFromJSON(json: any): CreateQuickReplyRequest {
    return CreateQuickReplyRequestFromJSONTyped(json, false);
}

export function CreateQuickReplyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateQuickReplyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shortName': json['shortName'],
        'description': json['description'],
        'message': json['message'],
    };
}

export function CreateQuickReplyRequestToJSON(json: any): CreateQuickReplyRequest {
    return CreateQuickReplyRequestToJSONTyped(json, false);
}

export function CreateQuickReplyRequestToJSONTyped(value?: CreateQuickReplyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shortName': value['shortName'],
        'description': value['description'],
        'message': value['message'],
    };
}

